// TODO: 回复的信息不在点赞模块上面
import React, { useCallback, useMemo, useState } from "react";
import { dateTrans, jointImgUploadByUser } from "@/lib/commonService";
import { zan } from "@/src/models/review";
import ReviewCommentForm from "../ReviewCommentForm";
import { FmIcon, FmImage, FmRating } from "@/ui-component";
import { useUserInfoContext } from "@/src/provider";
import classnames from "classnames";
import stl from "./reviewItem.module.scss";
import variable from "@/src/styles/variables.module.scss";
import { EIconType } from "@/public/static/interface";

interface IProps {
    data: any;
    productId: number;
    imgClick: any;
    imgs: any;
    changeReplayInfo?: any;
    isShowMore?: boolean;
}
const iconLike: EIconType[] = ["icon--like2", "icon--like1"];
const ReviewItem: React.FC<IProps> = (props) => {
    const { data, imgClick, imgs, productId, isShowMore } = props;
    const [userInfo] = useUserInfoContext((state) => [state.data]);

    const [isZan, setIsZan] = useState(data.is_zan !== 0);
    const [number_zan, setNumberZan] = useState<number>(data.number_zan);
    const [reply_info, setReplyInfo] = useState<Record<string, any>[]>(
        data.reply_info || [],
    );
    const [commentShow, setCommentShow] = useState(false);
    const toggerCommentShow = () => {
        setCommentShow((prev) => !prev);
    };

    const changeReplayInfo = useCallback(
        (data: any) => {
            let _replay_item = {
                customers_id: userInfo.customers_id,
                customers_name: `${userInfo.customers_firstname} ${userInfo.customers_lastname}`,
                date_added: parseInt(`${new Date().getTime() / 1000}`),
                master_id: data.master_id,
                parent_id: data.parent_id,
                reply_customer: data.customers_name,
                reply_text: data.reviews_text,
            };

            setReplyInfo((prev) => [_replay_item, ...prev]);
        },
        [
            userInfo.customers_firstname,
            userInfo.customers_id,
            userInfo.customers_lastname,
        ],
    );

    //点赞功能
    const praise = useCallback(async () => {
        try {
            zan(data.reviews_id);
            let prevZan: boolean;
            setIsZan((preState) => {
                prevZan = preState;
                return !preState;
            });
            setNumberZan((preState) => (prevZan ? preState - 1 : preState + 1));
        } catch (e) {
            console.log(e);
        }
    }, [data.reviews_id]);

    const {
        reviews_photo,
        date_added,
        reviews_rating,
        webp_url,
        customers_name,
        reviews_text,
    } = useMemo(() => data, [data]);

    const imgUrl = useMemo<string>(
        () => jointImgUploadByUser(reviews_photo),
        [reviews_photo],
    );

    return (
        <>
            <div className={stl["review-item-container"]}>
                <div
                    className={classnames(
                        "default_layout",
                        stl["star-container"],
                    )}
                >
                    <FmRating
                        classes={{
                            root: stl["icon-size"],
                        }}
                        value={parseFloat(reviews_rating)}
                        hiddenRatingNum
                    />
                </div>
                <div
                    className={stl["review-text"]}
                    dangerouslySetInnerHTML={{ __html: `${reviews_text}` }}
                ></div>
                <p className={stl["review-time"]}>
                    by {customers_name} on {dateTrans(date_added)}
                </p>
                {imgUrl && (
                    <div
                        className={stl["review-user-img-container"]}
                        onClick={(e) => {
                            let index = imgs.findIndex(
                                (i: any) => i.src === imgUrl,
                            );
                            index = index >= 0 ? index : 0;
                            imgClick(true, imgs, index);
                        }}
                    >
                        <FmImage
                            defaultImage={imgUrl}
                            image={jointImgUploadByUser(webp_url)}
                        />
                    </div>
                )}
                {isShowMore && (
                    <>
                       {!data.intl &&  <div
                            className={classnames(
                                "default_layout",
                                stl["show-more"],
                            )}
                        >
                            <FmIcon
                                onClick={toggerCommentShow}
                                icon="icon--ask"
                                className={stl["icon-ask"]}
                            />

                            {/* 需要图标表示点赞之前和点赞之后 */}
                            <FmIcon
                                onClick={praise}
                                icon={iconLike[Number(isZan)]}
                                className={classnames(
                                    stl["icon-like"],
                                    "icon-like--" + isZan + data.is_zan,
                                    iconLike[Number(isZan)],
                                )}
                            />
                            {number_zan > 0 && (
                                <div
                                    style={{
                                        color: variable.main,
                                        marginLeft: "0.1rem",
                                    }}
                                >
                                    {`(${number_zan})`}
                                </div>
                            )}
                        </div>}

                        {commentShow && (
                            <div className={stl["comment-container"]}>
                                <ReviewCommentForm
                                    header={data.customers_name}
                                    id={data.reviews_id}
                                    productId={productId}
                                    changeTotal={(data: any) => {
                                        changeReplayInfo(data);
                                        toggerCommentShow();
                                    }}
                                />
                            </div>
                        )}
                        {/* 评论内容 */}
                        <div>
                            {reply_info &&
                                reply_info.map((item: any, index: number) => (
                                    <div
                                        className={stl["reply-info"]}
                                        key={index}
                                    >
                                        <div
                                            className={classnames(
                                                "default_layout",
                                                stl["reply-info-item"],
                                            )}
                                        >
                                            <p className={stl["reply-p"]}>
                                                <span
                                                    className={
                                                        stl["customer-name"]
                                                    }
                                                >
                                                    {item.customers_name}
                                                </span>
                                                reply
                                                <span
                                                    className={classnames(
                                                        stl["review-time"],
                                                        stl["date-added"],
                                                    )}
                                                >
                                                    {dateTrans(item.date_added)}
                                                </span>
                                            </p>
                                        </div>
                                        <div
                                            className={stl["review-text"]}
                                            dangerouslySetInnerHTML={{
                                                __html: `${item.reply_text}`,
                                            }}
                                        ></div>
                                    </div>
                                ))}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default ReviewItem;
